export interface INotesContentProps {
  title: string;
}

export const ContentHeader = ({ title }: INotesContentProps) => {
  return (
    <>
      <h1>{title}</h1>
    </>
  );
};
